import * as React from 'react';

interface Props {
  className: string;
}

export const Arrow: React.FC<Props> = (props) => (
  <svg className={props.className} width="47" height="8" viewBox="0 0 47 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 4L46 4M46 4L43.4118 1M46 4L43.4118 7" stroke="#7C7C7C" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const DarkArrow: React.FC<Props> = (props) => (
  <svg className={props.className} width="51" height="12" viewBox="0 0 51 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.75" d="M50.5303 6.53033C50.8232 6.23744 50.8232 5.76256 50.5303 5.46967L45.7574 0.696699C45.4645 0.403806 44.9896 0.403806 44.6967 0.696699C44.4038 0.989593 44.4038 1.46447 44.6967 1.75736L48.9393 6L44.6967 10.2426C44.4038 10.5355 44.4038 11.0104 44.6967 11.3033C44.9896 11.5962 45.4645 11.5962 45.7574 11.3033L50.5303 6.53033ZM0 6.75H50V5.25H0V6.75Z" fill="#111D26"/>
  </svg>
)
